module.exports = __webpack_public_path__ + "img/spent-amount.5e196b64.svg";